import request from "@/utils/request";

// 获取花稿易难度
export function getFacilityValueList(data) {
  return request({
    url: "/pdm/commonDictionary/queryByGroupIdentification/facilityValue",
    method: "get",
    data: data
  });
}
// 启动花稿设计流程
export function companyDesignSave(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/start",
    method: "post",
    data: data
  });
}
// 申请实物样审批
export function physicalSampleCommit(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/physicalSampleCommit",
    method: "post",
    data: data
  });
}
// 查看附件
export function queryCommonAttachmentByColorId(data) {
  return request({
    url: "/pdm/commonAttachment/queryCommonAttachmentByColorId?colorId=" + data,
    method: "get",
    data: data
  });
}
// 修改附件
export function flowerDesignFileUpdate(data) {
  return request({
    url: "/pdm/commonAttachment/flowerDesignFileUpdate",
    method: "post",
    data: data
  });
}
// 提交流程
export function commit(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/commit",
    method: "post",
    data: data
  });
}
// 获取花稿设计驳回原因枚举
export function getFlowerDesignRejectReasonList(data) {
  return request({
    url: "/pdm/commonDictionary/queryByGroupIdentification/flowerDesignRejectReason",
    method: "get",
    data: data
  });
}
// 花稿设计不通过
export function rejectSave(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/rejectSave",
    method: "post",
    data: data
  });
}
// 获取供应商与二次跟单员
export function getSecondaryCopycatCodeList(data) {
  return request({
    url: "/pdm/pdmSecondaryProcessingFactory/selectAll",
    method: "get",
    data: data
  });
}

// 导出花稿信息
export function downloadFlowerDesign(data) {
  return request({
    url: "/pdm/commonAttachment/download",
    method: "post",
    responseType: "arraybuffer",
    data: data
  });
}

// 获取花稿设计跟进左边tab统计
export function countFlowerDesign() {
  return request({
    url: "/pdm/pdmFlowerDesign/countFlowerDesign",
    method: "get"
  });
}

// 花稿设计-->待处理，已处理统计
export function countFlowerByStatus(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/countFlowerByStatus/" + data,
    method: "get",
    data: data
  });
}
export function savePdmFlowDesign(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/insertOrUpdate",
    method: "post",
    data: data
  });
}
export function getFlowerDesignDetail(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/queryByFlowerDesignOrderNo/" + data,
    method: "get"
  });
}